"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditSubmittedLoanActionMetadata = void 0;
const Loans_1 = require("../types/Loans");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isEditSubmittedLoanActionMetadata = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Loans_1.EditSubmittedLoanActionMetadataSchema,
    typeguardName: 'isEditSubmittedLoanActionMetadata',
});
//# sourceMappingURL=loan.js.map